import { useState } from "react";
import { Modal } from "./Modal";
import type { WithdrawalBody } from "../api/portal";

interface WithdrawalDialogProps {
  /** YYYY-MM-DD, the form's default and its max. */
  today: string;
  busy?: boolean;
  error?: string | null;
  onSubmit: (body: WithdrawalBody) => void;
  onCancel: () => void;
}

/** Records that FINTRAC deleted this report. Nothing is sent to FINTRAC:
 *  the deletion already happened there (spec 2026-10-07 §4). */
export function WithdrawalDialog({ today, busy, error, onSubmit, onCancel }: WithdrawalDialogProps) {
  const [date, setDate] = useState(today);
  const [reason, setReason] = useState<WithdrawalBody["reason"]>("SUBMITTED_IN_ERROR");
  const [note, setNote] = useState("");

  const submit = () => {
    const trimmed = note.trim();
    onSubmit({ withdrawn_at: date, reason, ...(trimmed ? { note: trimmed } : {}) });
  };

  return (
    <Modal title="Record FINTRAC withdrawal" onClose={onCancel}>
      <h3>Record FINTRAC withdrawal</h3>
      <ul className="consequences">
        <li>Use this only after FINTRAC has deleted the report. Nothing is sent to FINTRAC.</li>
        <li>The report will read “Withdrawn from FINTRAC” for the customer and stop counting as filed.</li>
        <li>This cannot be undone from the portal.</li>
      </ul>
      <label>
        Date FINTRAC deleted it
        <input type="date" value={date} max={today} onChange={(e) => setDate(e.target.value)} />
      </label>
      <label>
        Reason
        <select value={reason}
                onChange={(e) => setReason(e.target.value as WithdrawalBody["reason"])}>
          <option value="SUBMITTED_IN_ERROR">Submitted in error</option>
          <option value="DUPLICATE">Duplicate</option>
        </select>
      </label>
      <label>
        Note (visible to the customer)
        <textarea maxLength={1000} value={note} onChange={(e) => setNote(e.target.value)} />
      </label>
      {error && <p className="empty">{error}</p>}
      <div className="modal-actions">
        <button onClick={onCancel} disabled={busy}>Cancel</button>
        <button className="btn-danger" onClick={submit} disabled={busy || !date}>
          {busy ? "Working…" : "Record withdrawal"}
        </button>
      </div>
    </Modal>
  );
}
